import { matchPath } from 'react-router-dom';
export default matchPath;
